/**
 * Handle script loading errors gracefully
 * Prevents UI crashes when scripts fail to load
 */
export default function ({ app }) {
  if (process.client) {
    // Handle script loading errors
    window.addEventListener('error', (event) => {
      // Check if it's a script loading error
      if (event.target && event.target.tagName === 'SCRIPT') {
        const src = event.target.src || event.target.getAttribute('src')
        if (src && src.includes('/_nuxt/')) {
          console.warn('Script loading failed, attempting recovery:', src)
          // Don't prevent default - let browser handle it
          // But we can try to reload the page after a delay if needed
          // Only reload if it's a critical script
          if (src.includes('app.js') || src.includes('commons.app.js')) {
            setTimeout(() => {
              if (document.readyState === 'loading') {
                window.location.reload()
              }
            }, 2000)
          }
        }
      }
    }, true) // Use capture phase

    // Handle unhandled promise rejections that might be related
    window.addEventListener('unhandledrejection', (event) => {
      const reason = event.reason
      if (reason && typeof reason === 'object' && reason.message) {
        if (reason.message.includes('Loading chunk') || reason.message.includes('Loading CSS')) {
          console.warn('Chunk loading failed, page may need refresh:', reason.message)
          event.preventDefault() // Prevent default error handling
        }
      }
    })
  }
}

